import { Api } from '../api';
import { createUrl } from '../../helpers/uri-factory';

const url = createUrl('academic');

export class GetStudentsByBookAndCareer extends Api {
  constructor(http, config = {}) {
    super(http, url, 'getStudentsByBookAndCareer', config);
  }
}